module.exports = __webpack_public_path__ + "img/discord.7879e235.svg";